/**
 * Each person's own overview, their reports by email, and what customers are
 * worth (ADR-109).
 */
/** The overview's sections, in the default order. */
export const DASHBOARD_SECTIONS = [
    'metrics',
    // ADR-121: what to do next, and the month against its goal.
    'insights',
    'target',
    'salesTrend',
    'topSellers',
    'actionQueue',
    'lowStock',
    'customersToCall',
    'recentOrders',
    'visits',
    'myFollowUps',
    // ADR-121: right now — refreshed while open, so off until someone wants it.
    'live',
];
/** Off for whoever never arranged: the two sections ADR-109 added keep the overview as it was. */
export const DASHBOARD_HIDDEN_BY_DEFAULT = ['visits', 'myFollowUps', 'live'];
export function defaultDashboardLayout() {
    return { sections: DASHBOARD_SECTIONS.map((id) => ({ id, hidden: DASHBOARD_HIDDEN_BY_DEFAULT.includes(id) })) };
}
/**
 * A saved layout as read: known sections once each, in the saved order; a
 * section it does not mention — one a later release added — goes in after
 * the section it follows by default, at its default visibility.
 */
export function readDashboardLayout(value) {
    const saved = (value && typeof value === 'object' ? value.sections : null) ?? [];
    const sections = [];
    for (const entry of Array.isArray(saved) ? saved : []) {
        const id = entry?.id;
        if (!DASHBOARD_SECTIONS.includes(id) || sections.some((section) => section.id === id))
            continue;
        sections.push({ id: id, hidden: entry.hidden === true });
    }
    DASHBOARD_SECTIONS.forEach((id, index) => {
        if (sections.some((section) => section.id === id))
            return;
        const before = index === 0 ? -1 : sections.findIndex((section) => section.id === DASHBOARD_SECTIONS[index - 1]);
        sections.splice(before + 1, 0, { id, hidden: DASHBOARD_HIDDEN_BY_DEFAULT.includes(id) });
    });
    return { sections };
}
/** How often a staff member gets the store summary by email. */
export const REPORT_DIGESTS = ['OFF', 'DAILY', 'WEEKLY', 'MONTHLY'];
//# sourceMappingURL=dashboard.js.map